/* istanbul ignore file */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { ChevronRight, ChevronLeft } from 'react-feather';
import Box from '@material-ui/core/Box';
import TabPanelContent from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/MyguaranteesBloc/TabPanelContent';
import TabPanelContentWithoutVideo from 'containers/MyguaranteesBloc/TabPanelContent';
import { StyledShortBody } from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/MyguaranteesBloc/style';
import { getVideoIdFormUrl } from 'utils/string';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  className: string;
  value: any;
}
/* istanbul ignore next */
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box px={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: any) {
  /* istanbul ignore next */
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    display: 'flex',
    height: 273,
  },
  tabs: {
    width: '100%',
  },
  wrapperSelected: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
  },
  wrapperNotSelected: {
    flexDirection: 'inherit',
    justifyContent: 'space-between',
    letterSpacing: '0',
    lineHeight: '16px',
    color: '#162952',
  },
  rootTab: {
    minHeight: '50px',
    minWidth: '100%',
  },
  selected: {
    borderRadius: '8px',
    backgroundColor: '#E8F3F8',
    color: '#0075C9',
  },
  indicator: {
    display: 'none',
  },
  tabPanelRoot: {
    width: '130%',
    marginTop: 50,
  },
  tabPanelRoot1: {
    width: '130%',
    marginTop: 0,
  },
});

export default function VerticalTabs({ items }: { items: any }) {
  const [value, setValue] = React.useState(0);
  const classes = useStyles();
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const Chevron = reverse ? ChevronLeft : ChevronRight;

  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs"
        className={classes.tabs}
        classes={{
          indicator: classes.indicator,
        }}
      >
        {items.map(
          (
            item: {
              title: string;
              panel: React.ReactNode;
            },
            index: number,
          ) => (
            <Tab
              key={index}
              classes={{
                wrapper:
                  index === value
                    ? classes.wrapperSelected
                    : classes.wrapperNotSelected,
                root: classes.rootTab,
                selected: classes.selected,
              }}
              label={
                <StyledShortBody isSelected={index === value} weight="500">
                  {item.title}
                </StyledShortBody>
              }
              icon={index === value ? <Chevron /> : <></>}
              {...a11yProps(index)}
            />
          ),
        )}
      </Tabs>
      {items.map(
        (
          item: {
            title: string;
            description: string;
            video: string;
          },
          index: number,
        ) => (
          <TabPanel
            key={index}
            value={value}
            index={index}
            className={
              items.length > 5 ? classes.tabPanelRoot : classes.tabPanelRoot1
            }
          >
            {item.video ? (
              <TabPanelContent
                title={item.title}
                body={item.description}
                videoId={getVideoIdFormUrl(item.video)}
              />
            ) : (
              <TabPanelContentWithoutVideo
                title={item.title}
                body={item.description}
              />
            )}
          </TabPanel>
        ),
      )}
    </div>
  );
}
